import { createFileRoute } from '@tanstack/react-router';

import { CompletionPage } from '@/features/design/completion-page';

export const Route = createFileRoute('/_app/projects/$projectId/design/completion')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <CompletionPage projectId={projectId} />;
}
